<template>
    <div class="home">
        <div class="top-info">
            <nav-login/>
        </div>
        <div class="searchbar">
            <h1>17共享网检验检测能力数据库</h1>
            <div class="tabs">
                <span v-for="(item,index) in tablist" :class="{active:isTab===index}" :key="index"
                      @click.stop="show(index)">{{item.tit}}</span>
            </div>
            <div class="ordinarySearch" v-show="!isshow">
                <div class="select" @mouseenter="enter" @mouseleave="leave">
                    <span>{{showName}}<i class="el-icon-arrow-down"></i></span>
                    <ul v-show="isshowName">
                        <li v-for="(item, index) in liList" :key="index" @click.stop="showName=item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </div>
                <el-input placeholder="请输入要查询的内容" v-model="ordinarySearchData" class="input-with-select" @keyup.enter.native="sendOrdinarySearchData">
                    <el-button slot="append" @click="sendOrdinarySearchData" @keyup.enter="sendOrdinarySearchData">搜索</el-button>
                </el-input>
            </div>
            <div class="accurateSearch" v-show="isshow" @keyup.enter="sendOrdinarySearchData">
                <div class="box">
                    <div class="left">
                        <el-input v-model="input1" placeholder="输入检测对象关键字"></el-input>
                        ---
                        <el-input v-model="input2" placeholder="输入项目检测关键字"></el-input>
                        ---
                        <el-input v-model="input3" placeholder="输入检测标准关键字"></el-input>
                        <el-button plain @click="sendOrdinarySearchData">搜索</el-button>
                    </div>
                </div>
                <div class="select" @mouseenter="enter" @mouseleave="leave">
                    <span>{{showName}} <i class="el-icon-arrow-down"></i></span>
                    <ul v-show="isshowName">
                        <li v-for="(item, index) in liList" :key="index" @click.stop="showName=item.name">
                            {{item.name}}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="box"></div>
        <div class="banner">
            <el-carousel direction="horizontal" :autoplay="true" :height="height+'px'" indicator-position="none">
                <el-carousel-item v-for="(item,index) in imgUrl" :key="index">
                    <img :src="item.img" alt="">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="foot">
            <span>&copy;2019中科融创科技有限公司</span>
            <span>蜀ICP备16034344</span>
        </div>
    </div>
</template>
<script>
  import NavLogin from '@/components/common/NavLogin'
  import {mapState} from 'vuex'

  export default {
    data () {
      return {
        imgUrl: [
          {img: '../../../static/images/1.jpg'},
          {img: '../../../static/images/2.jpg'},
          {img: '../../../static/images/3.jpg'},
          {img: '../../../static/images/4.jpg'}
        ],
        height: '',
        isshow: 0,
        tablist: [
          {tit: '普通搜索', show: true},
          {tit: '精准搜索', show: false}
        ],
        liList: [
          {name: '检验检测'},
          {name: '计量校准'}
        ],
        showName: '检验检测',
        isshowName: false,
        isTab: 0,
        searchData: '',
        ordinarySearchData: '',
        input1: '',
        input2: '',
        input3: '',
        input: '',
        selectName: '检验检测'
      }
    },
    methods: {
      getHeight () {
        this.height = window.innerHeight
      },
      enter () {
        this.isshowName = true
      },
      leave () {
        this.isshowName = false
      },
      show (index) {
        this.isTab = index
        this.isshow = index
      },
      sendOrdinarySearchData () {
        if (this.isTab === 0) {
          let dataArr = [this.isTab, this.ordinarySearchData, this.showName]
          this.$store.commit('addOrdinarySearchData', dataArr)
          sessionStorage.setItem('store', JSON.stringify(this.$store.state.ordinarySearchData))
          this.$router.push({name: 'SearchList'})
        } else if (this.isTab === 1) {
          let dataArr = [this.isTab, this.input1, this.input2, this.input3, this.showName]
          this.$store.commit('addOrdinarySearchData', dataArr)
          sessionStorage.setItem('store', JSON.stringify(this.$store.state.ordinarySearchData))
          this.$router.push({name: 'SearchList'})
        }
      },
      getSearchData () {
        if (!this.ordinarySearchData) {
          this.$message('请输入内容')
        } else {
          this.$router.push({
            name: 'SearchList',
            params: {
              name: this.ordinarySearchData,
              type: this.showName,
              statu: this.istrue
            }
          })
        }
      },
      getSearchData2 () {
        if (!this.input1 && !this.input2 && !this.input3) {
          this.$message('请输入内容')
        } else {
          this.$router.push({
            name: 'SearchList',
            params: {
              name: this.input1,
              category: this.input2,
              standard: this.input3,
              type: this.showName,
              statu: this.istrue
            }
          })
        }
      }
    },
    created () {
      this.getHeight()
      window.addEventListener('resize', this.getHeight)
    },
    computed: {
      ...mapState({
        OrdinarySearchData: state => state.OrdinarySearchData
      })
    },
    destroyed () {
      window.removeEventListener('resize', this.getHight)
    },
    components: {
      NavLogin
    }
  }
</script>

<style>
    .home {
        position: relative;
    }

    .home .top-info {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 9999;
        color: #fff;
    }

    .home .box {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.55);
        z-index: 99;
    }

    .home .searchbar {
        width: 940px;
        /*height: 80px;*/
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -470px;
        margin-top: -250px;
        z-index: 999;
        text-align: center;
    }

    .home .searchbar .tabs {
        height: 190px;
        line-height: 190px;
    }

    .home .searchbar .tabs span {
        width: 140px;
        height: 50px;
        border-radius: 4px;
        color: #fff;
        font-size: 22px;
        padding: 11px 31px;
        border: 1px solid #dddddd;
        cursor: pointer;
    }

    .home .searchbar .tabs span:first-child {
        margin-right: 50px;
    }

    .home .ordinarySearch {
        position: relative;
    }

    .home .select {
        position: absolute;
        top: 0;
        left: -160px;
        /*width: 130px;*/
        height: 69px;
        text-align: center;
        line-height: 69px;
        font-size: 24px;
        color: #fff;
    }

    .home .select ul li {
        cursor: pointer;
    }

    .home .accurateSearch {
        position: relative;
        /*display: none;*/
    }

    .home .accurateSearch .box .left {
        background: #fff;
        border-radius: 4px;
        line-height: 70px;
    }

    .home .accurateSearch .box .left .el-button {
        border: 1px solid #00cccc;
        height: 80px;
        width: 110px;
        font-size: 22px;
        background: #00cccc;
        text-align: center;
        margin-left: 69px;
        padding: 0;
        color: #fff;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    .home .accurateSearch .box .left .el-button span {
        padding: 1px;
    }

    .home .accurateSearch .box .left .el-input {
        width: 140px;
        border: none;
        padding: 0 50px;
        height: 70px;
    }

    .home .accurateSearch .box .left .el-input .el-input__inner {
        border: 1px solid #fff;
        padding: 0;
    }

    .active {
        border: 1px solid #00cccc !important;
        background: #00cccc;
    }

    .home .searchbar .ordinarySearch .el-input__inner {
        height: 80px;
    }

    .home .searchbar .el-input-group__append {
        background-color: #00cccc;
        border: none;
        color: #fff;
        width: 70px;
        text-align: center;
        line-height: 70px;
        font-size: 22px;
    }

    .home .searchbar h1 {
        font-size: 46px;
        font-weight: bold;
        color: #fff;
        /*margin-bottom: 190px;*/
    }

    .banner img {
        width: 100%;
        height: 100%;
    }

    .home .foot {
        position: absolute;
        bottom: 0;
        left: 50%;
        color: #fff;
        z-index: 99999;

    }
</style>



// WEBPACK FOOTER //
// src/components/home/home.vue